module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGklEQVR4nGPYuHHjf0oww6gBowaMGjBcDAAAfJQSLqPaZGoAAAAASUVORK5CYII="